import type { Language } from '@application/types';
import type { IconName } from '@fortawesome/fontawesome-svg-core';
import type { LocationDescriptor } from 'history';
import type { MouseEventHandler, ReactNode } from 'react';
import type { LanguageSelectorProps } from '../Header/components/LanguageSelector';

export interface MtLayoutDropdownLink {
  label: string;
  icon: IconName;
  notifications?: number;
  disabled?: boolean;
  onClick?: () => void;
}

export interface MtLayoutNavbarLinkCategory {
  label?: string;
  bottomPinned?: boolean;
  links: MtLayoutNavbarLink[];
}

export interface MtLayoutNavbarLink {
  label: string;
  icon?: IconName;
  tag?: string;
  onClick?: () => void;
  active?: boolean;
  highlight?: boolean;
  disabled?: boolean;
  tooltip?: string;
  notifications?: number;
  notificationColor?: 'red';
}

export interface MtLayoutAlertBarData {
  title: ReactNode;
  content: ReactNode;
  loading?: boolean;
  link?: LocationDescriptor;
  linkText?: ReactNode;
  showProfileProgress?: boolean;
  theme?: 'success' | 'warning';
  onClick?: MouseEventHandler;
  onDismissClick?: MouseEventHandler;
}

export interface MtLayoutData {
  user: {
    name: string;
    image?: string;
  };
  dropdownLinks: MtLayoutDropdownLink[];
  navbarLinkCategories: MtLayoutNavbarLinkCategory[];
  onHomeClick?: () => void;
  onLanguageChange?: (language: Language) => void;
  onLogoutClick: () => void;
  alertBar?: MtLayoutAlertBarData;
  partnershipAlertBar?: MtLayoutAlertBarData;
  unfinishedApplicationComponent: ReactNode;
  notificationsPanel?: ReactNode;
  profileCurrentProgress?: number;
}

export interface MtLayoutProps
  extends MtLayoutData,
    Pick<LanguageSelectorProps, 'languageSelectorButtons'> {
  children: ReactNode;
}

export interface NavigationProps {
  navbarLinkCategories: MtLayoutNavbarLinkCategory[];
  onLogoutClick: () => void;
  isMobile?: boolean;
}
